import { post, get } from '../utils/fetch';

// 核心资源的API
export default class CoreResourceService {
    // 藏品列表
    static fetchRelicList(params) {
        return get('/relic/api/v1/relic/querylist', params)
    }
   
}




// WEBPACK FOOTER //
// ./src/api/coreResourceService.js